<template>
  <div id="newUserContainer">
    <user/>
  </div>
</template>

<script>
import User from './User'
export default {
  components: {
    User
  }
}
</script>
